module.exports = {
      id: "usd-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#usd-usage",
      toString: function () {
        return this.url;
      }
    }